import { makePragma } from "@lightmode/sx"
import { theme } from "./theme"
import sxCSS from "@styled-system/css"
import { css } from "emotion"

const jsx = makePragma(theme)

function csx(style) {
  return css(sxCSS(style)(theme))
}

export { jsx, csx }
